<!-- 询单详情 -->
<template>
    <div>
        <div class="container" v-for="(items, indexs) in datas" :key="indexs">
            <el-card class="card1" shadow="hover">
                <div class="cardLeft">
                    <div class="imgsBox">
                        <img class="imgs" :src="items.imageUrl" alt="">
                        <div class="types">
                            专属
                        </div>
                    </div>
                    <div class="info">
                        <p class="infoP1">{{ items.nameCn ? items.nameCn : items.nameEn }}</p>
                        <p class="infoP2" v-if="items.addressCn"> <i class="el-icon-location"></i> {{ items.addressCn }}</p>
                        <el-tooltip :open-delay="500" popper-class="inquiryDetailTooltip" effect="dark" placement="top">
                            <p style="width: 4.5rem;" slot="content">{{ items.introduction }}</p>
                            <p class="infoP3">{{ items.introduction }}</p>
                        </el-tooltip>
                    </div>
                </div>
                <div class="cardRight">
                    <div class="cardRightTop">
                        <!-- <div class="cardRightTopLine1">
                        <i class="el-icon-star-off icon1"></i>
                        <el-button size="mini" class="btns" type="primary">加入报价</el-button>
                    </div> -->
                        <div class="cardRightTopLine2">
                            <!-- <div class="yuan">
                            抢
                        </div> -->
                            <p class="cardRightTopLine2P1">{{ items.score }}分<span>/5分</span></p>
                        </div>
                    </div>
                    <div class="cardRightBottom">
                        <i @click="launchClick(items)" class="el-icon-caret-bottom icon2"
                            :class="items.isShow ? 'up' : 'down'"></i>
                        <p class="cardRightBottomP1">{{ allTotalPrice(items.stockListResults) }}<span>{{ items.currency
                        }}</span></p>
                    </div>
                </div>
            </el-card>

            <el-collapse-transition>
                <div v-show="items.isShow">
                    <!-- :class="showSealOrNot(item) ? 'pointer-None' : ''" -->
                    <div class="detailListBox">
                        <div class="detailListBoxInfo"
                            :style="{ marginBottom: items.stockListResults.length - 1 === index ? 0 : '0.15rem' }"
                            v-for="(item, index) in items.stockListResults" :key="index">
                            <!-- ================= -->
                            <seal :text="item.isOrder == 1 ? '已下单' : '已发送'" v-if="item.isCancel === 2 && $store.state.orderFlowDirection == 1 || item.isOrder == 1" ></seal>
                            <!-- ================= -->
                            <el-checkbox :disabled="item.isCancel === 2 && $store.state.orderFlowDirection == 1 || item.isOrder === 1"
                                :value="checked.findIndex(n => n.stockId == item.stockId) !== -1"
                                @change="selectChange(item)"> <span class="detailListBoxInfoSpan1">{{ item.productNameCn ?
                                    item.productNameCn : item.productNameEn }}</span><span v-if="item.productDesc">（{{
        item.productDesc }}）</span> </el-checkbox>
                            <el-button v-if="item.isCancel === 2 && $store.state.orderFlowDirection == 1 && item.isOrder !== 1" type="primary"
                                @click="$emit('cancelClick', item)" style="margin-left: 0.1rem;"
                                size="mini">取消发送</el-button>
                            <p class="detailListBoxInfoP1">
                                <!-- <i v-if="item.recommendation" class="icon-aixin iconfont" style="color:#D81B43"></i>
                                <el-divider v-if="item.recommendation" direction="vertical"></el-divider> -->
                                <span class="detailListBoxInfoP1Span1" v-if="item.recommendation">{{ item.recommendation
                                }}</span>
                                <el-divider v-if="item.recommendation" direction="vertical"></el-divider>
                                <span class="detailListBoxInfoP1Span1" v-if="item.stockDesc">{{ item.stockDesc }}</span>
                                <el-divider v-if="item.stockDesc" direction="vertical"></el-divider>
                                <span>{{ item.cancelType == 1 ? '不可取消' : '有条件退' }} / Option{{ item.optionTime |
                                    dateFormatHms }}</span>
                            </p>
                            <div class="detailBox" v-for="(q, keys) in item.priceList" :key="keys">
                                <div class="detailListBoxInfoP2" v-for="(n, m) in q" :key="m">
                                    <div>
                                        <span class="detailListBoxInfoP2Span1" style="margin-right: 0.1rem;">{{ n.startDate
                                        }}<span v-if="n.endDate" class="detailListBoxInfoP2Span3"> 至 </span><span
                                                v-if="n.endDate">{{ n.endDate }}</span></span>
                                        <span v-if="$store.state.orderFlowDirection == 1">
                                            <span class="detailListBoxInfoP2Span2">成本：</span>
                                            <span class="detailListBoxInfoP2Span1">{{ n.price }} </span>
                                        </span>
                                        <span v-if="n.toCPrice" class="detailListBoxInfoP2Span2">报价：</span>
                                        <span v-if="n.toCPrice" class="detailListBoxInfoP2Span1">{{ n.toCPrice }}</span>
                                        <span class="detailListBoxInfoP2Span1">{{ n.currency }}/{{ n.priceCompany }}<span
                                                v-if="n.useTime">/{{ n.useTime }} </span></span>
                                        <span class="detailListBoxInfoP2Span1">{{ n.number }}{{ n.priceCompany }} <span
                                                v-if="n.useTime">{{ item.state == 0 ? days(n.startDate, n.endDate) :
                                                    days(n.startDate, n.endDate) + 1 }}{{ n.useTime }}</span></span>
                                        <span v-if="item.state == 0 && n.toCPrice && $store.state.orderFlowDirection == 1" class="detailListBoxInfoP2Span1"
                                            style="font-weight: bold;"> <span class="detailListBoxInfoP2Span2">
                                                利润：</span>{{ saleTotalPrice(days(n.startDate, n.endDate), n) -
                                                    totalPrice(days(n.startDate, n.endDate), n)
                                                }}{{ n.currency }}</span>
                                        <span v-if="item.state != 0 && n.toCPrice && $store.state.orderFlowDirection == 1" class="detailListBoxInfoP2Span1" style="font-weight: bold;"> <span
                                                class="detailListBoxInfoP2Span2"> 利润：</span>
                                            {{ saleTotalPrice(days(n.startDate, n.endDate) + 1, n) -
                                                totalPrice(days(n.startDate, n.endDate) + 1, n) }}{{ n.currency }}</span>
                                        <p v-if="n.remark">{{ item.state == 4 ? '菜品说明' : '备注' }}：{{ n.remark }}</p>
                                    </div>
                                    <el-button @click="modifyPrice(n)" size="mini" type="primary"
                                        style="margin-left: 0.1rem;"
                                        v-if="item.isCancel !== 2 && m == 0 && $store.state.orderFlowDirection == 1">修改报价</el-button>
                                </div>
                            </div>
                            <div class="detailListBoxInfoDiv1">
                                <div class="detailListBoxInfoDiv1Btn" v-for="item in policylist" :key="item">
                                    {{ item }}
                                </div>
                            </div>
                        </div>
                        <div class="detailListBoxInfoDiv2">
                            <i @click="items.isShow = false" class="el-icon-caret-top icon3"></i>
                        </div>
                    </div>
                </div>
            </el-collapse-transition>
        </div>
        <modifyQuotationPopup @updatePrice="updatePrice" ref="modifyQuotationPopup"></modifyQuotationPopup>
    </div>
</template>

<script>
import Api from '../../../../../../components/Api';
import { days, getGroup } from '@/assets/utils/unit'
import modifyQuotationPopup from './modifyQuotationPopup.vue';
import seal from './sealComponent.vue';
export default {
    props: {
        requestData: {
            type: Object,
            default: () => { }
        },
        checked: {
            type: Array,
            default: () => []
        }
    },
    components: {
        modifyQuotationPopup,
        seal
    },
    data() {
        return {
            days,
            datas: [],
            others: {},//已经操作了
            policylist: ['预定说明', '费用说明', '使用说明', '退改说明', '其它说明']
        }
    },
    computed: {
        //单挑数据的成本计算
        totalPrice() {
            return function (day, n) {
                let price = Number(day) * n.number * n.price
                return price.toFixed(2)
            }
        },
        saleTotalPrice() {
            return function (day, n) {
                let price = Number(day) * n.number * n.toCPrice
                return price.toFixed(2)
            }
        },
        //成本的总价计算
        allTotalPrice() {
            return function (arr) {
                let price = 0
                let dateArr = []
                arr.forEach(item => {
                    for (const key in item.priceList) {
                        item.priceList[key].forEach(item1 => {
                            this.$set(item1, 'state', item.state)
                        })
                        dateArr = [...dateArr, ...item.priceList[key]]
                    }
                })
                dateArr.forEach(item => {
                    let day = item.state == 0 ? this.days(item.startDate, item.endDate) : this.days(item.startDate, item.endDate) + 1
                    price += item.number * item.price * item.rate * day
                })
                return price.toFixed(2)
            }
        },
        showSealOrNot() {
            return (val) => {
                let obj = this.others.orderProfitInquiryStockList.find(n => n.stockId === val.stockId)
                return obj && obj.isOrder == 1
            }
        }
    },
    watch: {},
    methods: {
        //展开
        launchClick(items) {
            items.isShow = !items.isShow
        },
        //更新价格
        updatePrice(newPrice, stockPriceId) {
            console.log(this.datas, '看坎坎坷坷看看');
            this.datas.forEach(item => {
                item.stockListResults.forEach(item1 => {
                    for (const keys in item1.priceList) {
                        let obj = item1.priceList[keys].find(n => n.stockPriceId === stockPriceId)
                        console.log(obj, 'kkkkkkkk');
                        if (obj) {
                            this.$set(obj, 'toCPrice', newPrice)
                        }
                    }
                })
            })
            console.log(this.datas, '啦啦啦啦啦啦');
            this.$refs.modifyQuotationPopup.centerDialogVisible = false
        },
        projectInquiryStockList(arr = []) {
            if (this.datas.length === 0 || arr.length > 0) {
                new Api('resource').projectInquiryStockList(this.requestData).then(res => {
                    if (res.status === 200) {
                        this.datas = res.data
                        this.others = res.others
                        this.datas.forEach(item => {
                            this.$set(item, 'isShow', false)
                            if (arr.length > 0) {
                                arr.forEach(q => {
                                    q.orderProfitInquiryStockPriceDetailList.forEach(q1 => {
                                        let obj = item.stockListResults.find(n => n.stockId === q1.stockId)
                                        if (obj) {
                                            this.$set(item, 'isShow', true)
                                        }
                                    })
                                })
                            }
                            item.stockListResults.forEach(item1 => {
                                this.$set(item1, 'priceList', getGroup(item1.priceList, 'stockPriceId'))
                            })
                        })
                    } else {
                        this.$message({
                            type: 'warning',
                            message: res.statusText
                        });
                    }
                })
            }
        },
        //处理打包数据的勾选
        processPackagedData(mergerPurchase) {
            let arr = []
            this.datas.forEach(item => {
                if (item.stockListResults.findIndex(n => n.mergerPurchase === mergerPurchase) !== -1) {
                    this.$set(item, 'isShow', true)
                    let obj = item.stockListResults.find(q => q.mergerPurchase === mergerPurchase)
                    arr.push(obj)
                    console.log(arr, '快上课打瞌睡口');
                }
            })
            this.$emit('packagingData', arr)
        },
        //多选选择
        selectChange(val) {
            console.log(val, '看看数据及iii');
            const hasToCPrice = Object.values(val.priceList).some(item => {
                if (Array.isArray(item)) {
                    return item.some(subItem => subItem.toCPrice !== null && subItem.toCPrice !== undefined);
                }
                return false;
            });
            if (hasToCPrice) {
                this.$emit('checkDatas', val)
            } else {
                this.$message.warning({ message: '请您先修改报价' })
            }
        },
        //修改报价
        modifyPrice(val) {
            this.$refs.modifyQuotationPopup.initClick(val)
        }

    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.pointer-None {
    pointer-events: none;
}

.up {
    transform: rotate(-180deg);
    transition: all 0.1s ease;
}

.down {
    transition: all 0.1s ease;
}

.container {
    margin-bottom: 0.15rem;

    &:nth-last-child(1) {
        margin-bottom: 0;
    }
}

.detailBox {
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    width: 90%;
    padding: 0.1rem 0;
    border-radius: 0.1rem;
    margin-left: 0.25rem;
    margin: 0.05rem 0 0.1rem 0.25rem;
}

.card1 {
    border-radius: 15px 15px 0 0 !important;
    border-bottom: 2px solid #DE4D20;
    display: flex;
    align-items: center;
    position: relative;
    border: 1px solid #DE4D20;
    // box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.4);

    .cardLeft {
        display: flex;

        .imgsBox {
            height: 1rem;
            width: 1rem;
            position: relative;
            margin-right: 0.1rem;

            .imgs {
                height: 1rem;
                width: 1rem;
                border: 1px solid red;
            }

            .types {
                position: absolute;
                bottom: 0.05rem;
                right: 0.05rem;
                width: 0.5rem;
                height: 0.25rem;
                text-align: center;
                line-height: 0.25rem;
                color: #fff;
                font-weight: bold;
                background-color: rgba(219, 78, 26, 0.7);
            }
        }


        .info {
            .infoP1 {
                color: #000;
                font-weight: bold;
                font-size: 0.2rem;
            }

            .infoP2 {
                color: #A3ADB9;
            }

            .infoP3 {
                color: #A3ADB9;
                width: 5rem;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

    }

    .cardRight {
        position: absolute;
        bottom: 0;
        right: 0;
        height: 90%;
        min-width: 1.5rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .cardRightTop {
            background-color: #F2F4F4;
            height: 65%;
            padding: 0.07rem 0.1rem;
            // display: flex;
            // flex-direction: column;
            // justify-content: space-between;
            display: flex;
            align-items: center;
            justify-content: center;

            .cardRightTopLine1 {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .icon1 {
                    font-size: 0.22rem;
                }

                .btns {
                    background-color: #00A1C5;
                    border-color: #00A1C5;
                }
            }

            .cardRightTopLine2 {
                display: flex;
                align-items: center;

                .yuan {
                    height: 0.3rem;
                    width: 0.3rem;
                    border-radius: 50%;
                    background-color: #fff;
                    border: 1px solid #BBBBBB;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: red;
                    font-weight: bold;
                    margin-right: 0.05rem;
                }

                .cardRightTopLine2P1 {
                    font-size: 0.18rem;
                    color: red;
                    font-weight: bold;

                    span {
                        font-size: 0.14rem;
                        color: #696B78;
                    }
                }
            }
        }

        .cardRightBottom {
            background-color: #DD4C21;
            height: 30%;
            display: flex;
            align-items: center;
            justify-content: center;

            .icon2 {
                font-size: 0.3rem;
                cursor: pointer;
                color: #fff;
            }

            .cardRightBottomP1 {
                color: #fff;
                font-size: 0.2rem;

                span {
                    font-size: 0.12rem;
                    margin-left: 0.05rem;
                }
            }

        }
    }

}

.detailListBox {
    padding: 0.2rem 0.1rem 0 0.1rem;
    border: 1px solid #DD4C21;

    .detailListBoxInfo {
        position: relative;

        .detailListBoxInfoP1 {
            color: #105B69;
            font-weight: bold;
            margin: 0.05rem 0 0 0.25rem;

            .detailListBoxInfoP1Span1 {
                color: #D81B43;
                font-weight: bold;
            }
        }

        .detailListBoxInfoSpan1 {
            font-size: 0.17rem;
            color: #000;
            font-weight: bold;
        }

        .detailListBoxInfoP2 {
            margin: 0.05rem 0 0 0.25rem;
            display: flex;
            align-items: center;
            padding-right: 0.1rem;
            justify-content: space-between;

            .detailListBoxInfoP2Span1 {
                color: #000;
                font-weight: bold;
            }

            .detailListBoxInfoP2Span2 {
                color: #DD4C21;
            }

            .detailListBoxInfoP2Span3 {
                color: #606266;
            }
        }

        .detailListBoxInfoDiv1 {
            display: flex;
            margin: 0.05rem 0 0 0.25rem;

            .detailListBoxInfoDiv1Btn {
                width: 0.7rem;
                height: 0.25rem;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #DD4C21;
                background-color: #F2EDEC;
                border-radius: 2px;
                margin-right: 0.1rem;
                cursor: pointer;
            }
        }
    }

    .detailListBoxInfoDiv2 {
        display: flex;
        justify-content: flex-end;

        .icon3 {
            font-size: 0.3rem;
            cursor: pointer;
        }
    }
}
</style>